enum BrandType {

    TradeApp = "TradeApp",
    Financika = "Financika",
    FXGMZA = "FXGM-za",
    UBanker = "UBanker",
    SeventyTrades = "_70Trades",
    A3Trading = "A3Trading",
    TaoTrade = "TaoTrade",
    FXGM = "FXGM",
    GTCM = "GTCM",
    Fortissio = "Fortissio",
    Ontega = "Ontega",
    ForexCT = "ForexCT",
    TradoCenter = "TradoCenter",
    XLNTrade = "XLNTrade",
    WBSmith = "WBSmith",
    ToroInvest = "ToroInvest"
}

namespace BrandType {

    export function deserialize(type: string): BrandType {
        if (type === "70Trades") {
            return BrandType.SeventyTrades;
        } else if (type === "FXGM-za") {
            return BrandType.FXGMZA;
        } else if (type === "Warren Bowie & Smith") {
            return BrandType.WBSmith;
        }
        return BrandType[type] || type;
    }

    export function folder(brandId: number): string {
        if (brandId) {
            switch (brandId) {
                case 41:
                    return "fortissio";
                case 7:
                    return "fxgm";
                case 39:
                    return "70trades";
                case 33:
                    return "a3trading";
                case 29:
                    return "financika";
                case 2:
                    return "forexct";
                case 56:
                    return "fxgmza";
                case 23:
                    return "gtcm";
                case 60:
                    return "ontega";
                case 34:
                    return "taotrade";
                case 61:
                    return "tradeapp";
                case 62:
                    return "tradocenter";
                case 35:
                    return "ubanker";
                case 40:
                    return "xlntrade";
                case 63:
                    return "wbandsmith";
                case 64:
                    return "toroinvest";
            }
        }
        return null;
    }
}

export {BrandType};
